{{ value ? ((keepLocalTime ? getDateString(value) : value) | date : format) : emptyString }}
